import React from 'react';
import { useParams, useLocation } from 'react-router';
import PageTitle from 'components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import { DISPLAY_TYPES } from 'configs/localData/constant';
import {
  ThorContactControllerGetTableDataForCentreApiArg,
  useThorContactControllerGetTableDataForCentreQuery,
} from 'generated/apis';
import useRTKQueryInfiniteLoad from 'hooks/useRTKQueryInfiniteLoad';
import { getFilterFromUrl } from 'utils/tools';
import { getCentreId } from 'redux/auth/selectors';
import { useSelector } from 'react-redux';
import { UseQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { BaseQueryFn, QueryDefinition } from '@reduxjs/toolkit/dist/query';
import GridView from '../components/GridView';
import ListStyles from './styles';
import AlphabetBar from '../components/AlphabetBar';
import HeaderFilter from './HeaderFilter';
import TableView from '../components/TableView';

const ContactsList = () => {
  const { model } = useParams();
  const activeTab = model || DISPLAY_TYPES.board;
  const { t } = useTranslation();

  const centreId = useSelector(getCentreId);
  const { search } = useLocation();
  const { filter: query } = getFilterFromUrl(search);

  const restFilter = {
    ...query,
    createdAt: query?.createdAt,
    lastActiveAt: query?.lastActiveAt,
    centreId: centreId || null,
  };

  const { data, isFetching, total, fetchNextPage, refresh } =
    useRTKQueryInfiniteLoad({
      useQuery: useThorContactControllerGetTableDataForCentreQuery as UseQuery<
        QueryDefinition<
          ThorContactControllerGetTableDataForCentreApiArg,
          BaseQueryFn,
          string,
          any
        >
      >,
      searchKey: '',
      queryParams: { ...restFilter },
    });

  return (
    <ListStyles>
      <PageTitle>{t('contacts.header')}</PageTitle>

      <HeaderFilter refresh={refresh} activeTab={activeTab} />
      {activeTab === DISPLAY_TYPES.board ? (
        <GridView
          data={data}
          isFetching={isFetching}
          total={total}
          fetchNextPage={fetchNextPage}
        />
      ) : (
        <>
          <div className="container-contact">
            <AlphabetBar />
            <TableView />
          </div>
        </>
      )}
    </ListStyles>
  );
};

export default ContactsList;
